import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import DialogActions from '@mui/material/DialogActions';

import { OPACITY_70 } from 'constants/opacity';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import { calculateRgbaWithAlpha } from 'helpers/colorFormatter';
import PrimaryCta from 'components/Buttons/PrimaryCta';
import { StyledTypographyColorSectionNavLinkMain } from 'components/Cart/StyledTypographyColorSectionNavLinkMain';
import { setSeatIdOnCart } from 'bento-ordering/investor_day/actions';

const StyledInputBase = styled(InputBase)(({ theme }) => {
  const {
    fontFamily,
    fontWeight,
    letterSpacing
  } = theme.typography.itemDescriptionsAndPrices;

  return {
    background: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontFamily,
    fontWeight,
    letterSpacing
  };
});

const SelectSeatIdModal = ({ toggleIsOpen }) => {
  const dispatch = useDispatch();
  const [seatId, setSeatId] = React.useState('');

  const getCtaStyles = theme => {
    const { fontFamily, fontWeight, letterSpacing } = theme.typography.header;
    return {
      fontFamily,
      fontWeight,
      letterSpacing,
      color: calculateRgbaWithAlpha(
        theme.palette?.button?.background?.hover,
        OPACITY_70
      )
    };
  };

  const onConfirmHandler = async event => {
    event.preventDefault();
    await dispatch(setSeatIdOnCart(seatId));
    toggleIsOpen();
  };

  const handleSeatIdInputChange = e => {
    const { value } = e.target;
    setSeatId(value);
  };

  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <>
        <StyledTypographyColorSectionNavLinkMain
          textAlign="center"
          component="h4"
          variant={ITEM_DESCRIPTION_AND_PRICES}
        >
          {`Please enter the seat ID for this order`}
        </StyledTypographyColorSectionNavLinkMain>

        <StyledInputBase
          placeholder={'e.g. 4.5'}
          value={seatId}
          onChange={handleSeatIdInputChange}
          inputProps={{ 'aria-label': 'seat id' }}
          sx={{ my: 1, pl: 1, flex: 1, borderRadius: 0.5 }}
          autoComplete="off"
        />
        <DialogActions>
          <Box mt={2}>
            <PrimaryCta
              label={'Update'}
              handleClick={onConfirmHandler}
              fullWidth
              sx={getCtaStyles}
            />
          </Box>
        </DialogActions>
      </>
    </Box>
  );
};

SelectSeatIdModal.propTypes = {
  toggleIsOpen: PropTypes.func.isRequired
};

export default SelectSeatIdModal;
